import { Avatar, Button, Grid, Stack } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';

import { IconPlus } from '@tabler/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AdminProductGrid from '../dashboard/AdminProductGrid';

const AdminProductPage = () => {
  const [params] = useSearchParams();
  console.log(params.get('id'));
  const navigate = useNavigate();

  return (
    <PageContainer
      title="Earnpati Admin Products Page"
      description="this is admin page for handling products of Earnpati"
    >
    <Stack direction="row" spacing={1} my={1} alignItems="center" >
    <Button variant='outlined' sx={{color:'#111'}} href="/admin/add-products" onClick={()=>navigate('/admin/add-products')}>
          <Avatar sx={{ bgcolor: '#CDF59C', width: 40, height: 40, marginRight:'5px' }}>
            <IconPlus
              width={36}
              color="#3141EB"
            />
          </Avatar>
          Add New Product
          </Button>
        </Stack>

      
      <Grid item xs={12} lg={8} sx={{ marginTop: '1rem' }}>
        <AdminProductGrid />
      </Grid>
    </PageContainer>
  );
};

export default AdminProductPage;
